import React, { useContext, useEffect, useState } from "react";
import { useLazyQuery } from "@apollo/client";
import { useNavigate } from "react-router-dom";

import { GET_APPLICATIONS } from "../../Graphql/queries/queryGetApplications";
import { GlobalContext } from "../../context/GlobalContext";
import { LoadingScreen } from "../../components/StatusScreens/LoadingScreen";
import { RoutesNames } from "../../components/utils/routes";
import { useRedirectLogged } from "../../Hooks/useRedirectLogged";
import { useToastError } from "../../Hooks/useToastError";
import ExportExcelOthers from "../../components/OptionList/ExportExcelOthers";
import HeaderMain from "../../components/header/headerMain";
import OptionRow from "../../components/OptionList/OptionRow";

import {
  ContainerGlobal,
  ContainerContent,
  ContainerButtons,
  ContainerSearch,
  Select,
  ContainerTable,
  ContainerHeader,
  ContainerData,
  ContainFieldHeader,
} from "../../styles/PageStyles/LegalAndDocumental/OthersFormsStyles";

const OthersForms = () => {
  useRedirectLogged();
  const router = useNavigate();
  const { rol } = useContext(GlobalContext);

  useEffect(() => {
    if (rol !== "ADMIN") {
      router(RoutesNames.login);
    }
  }, [rol, router]);

  const [option, setOption] = useState("RUMV_REGISTRY");

  const [getData, { error, data, loading }] = useLazyQuery(GET_APPLICATIONS);
  useToastError(error);

  useEffect(() => {
    getData({
      variables: {
        stepType: option,
      },
    });
  }, [getData, option]);

  useEffect(() => {
    getData({
      variables: {
        stepType: option,
      },
    });
  }, [option, setOption, getData]);

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <ContainerGlobal>
      <HeaderMain />
      <ContainerContent>
        <ContainerButtons>
          <ContainerSearch>
            <Select onChange={(e) => setOption(e.target.value)} value={option}>
              <option value="RUMV_REGISTRY">Registro RUMV</option>
              <option value="BIOMETRIC_REGISTRY">Registro Biométrico</option>
              <option value="DELIVERY_DOCUMENT">Entrega de documentos</option>
            </Select>
          </ContainerSearch>
          {data && <ExportExcelOthers arrayData={data?.getApplications} name={option} />}
        </ContainerButtons>
        <ContainerTable>
          <ContainerHeader>
            <ContainFieldHeader>NOMBRE</ContainFieldHeader>
            <ContainFieldHeader>APELLIDO</ContainFieldHeader>
            <ContainFieldHeader>DEPARTAMENTO</ContainFieldHeader>
            <ContainFieldHeader>MUNICIPIO</ContainFieldHeader>
          </ContainerHeader>
          <ContainerData>
            {data?.getApplications.map((item) => {
              return <OptionRow item={item} key={item.id} />;
            })}
          </ContainerData>
        </ContainerTable>
      </ContainerContent>
    </ContainerGlobal>
  );
};

export default OthersForms;
